import { Trans } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Label } from 'designSystem/components/Label'
import { Text } from 'designSystem/components/Text'
import React from 'react'

export type PageMetadataEvalDeferReasonProps = {
  reason: string
}

export function PageMetadataEvalDeferReason({
  reason,
}: PageMetadataEvalDeferReasonProps): React.ReactElement {
  return (
    <Box
      display='flex'
      align='baseline'
      wrap='wrap'
      width='full'
      shrink={false}>
      <Label>
        <Trans>Deferral reason:</Trans>
      </Label>
      <Text variant='body' color='muted'>
        {'\u00A0'}&quot;{reason}&quot;
      </Text>
    </Box>
  )
}
